import axios from 'axios';

const api = axios.create({
    // Local
    // baseURL: 'http://localhost:8000'
    
    // DESENVOLVIMENTO
    // baseURL: 'https://api-dev-painel-restaurante.appedidos.com.br'

    // PRODUÇÃO
    baseURL: 'https://api-painel-restaurante.appedidos.com.br'
})

export default api;